import React, { FC, SyntheticEvent, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { MetersEditModal } from '../MetersEditModal'
import { useIntl } from 'react-intl'
import CompanyMetersTable from './table/CompanyMetersTable'
import { useAuth } from '../../auth/core/AuthProvider'
interface MetersListProps {
  companyId?: any
  location?: any
}

const MetersList: FC<MetersListProps> = ({ companyId, location }) => {
  const [itemIdForUpdate, setItemIdForUpdate] = useState('')
  const [refreshFunction, setRefreshFunction] = useState<any>(() => {})
  const intl = useIntl()
  const { user } = useAuth()
  const canCreate = user?.permissions?.canCreateMeters ?? false
  const canUpdate = user?.permissions?.canUpdateMeters ?? false
  const canDelete = user?.permissions?.canDeleteMeters ?? false
  const restrictToAssignedSites =
    user?.scope?.level === 'site' ||
    (!!user?.roleFlags?.isSiteManager && !user?.roleFlags?.isAdmin && !user?.roleFlags?.isManager)
  const editableSiteIds = restrictToAssignedSites ? user?.scope?.sites ?? user?.sites ?? [] : null
  return (
    <>
      <CompanyMetersTable
        title={intl.formatMessage({ id: 'MENU.COMPANYMETERS' })}
        dataUrl={`/company/meters/list${companyId ? `?companyId=${companyId}` : ''}`}
        canEdit={canUpdate}
        canDelete={canDelete}
        editableSiteIds={editableSiteIds}
        editCallback={(id: any, refresh: Function) => {
          setRefreshFunction(() => refresh)
          setItemIdForUpdate(id)
        }}
        deleteCallback={(id: any, refresh: Function) => {
          axios.get('/company/meters/save/' + id).then((response) => {
            let csrfData = response.data.data
            Swal.fire({
              title: 'Warning',
              html: 'Are you want to delete this meter?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Delete',
              cancelButtonText: 'Cancel',
              customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-primary',
              },
            }).then((result) => {
              if (result.isConfirmed) {
                axios
                  .delete('company/meters/save/' + id, {
                    data: csrfData,
                  })
                  .then(() => {
                    refresh()
                  })
              }
            })
          })
        }}
        actionItems={
          canCreate
            ? [
                {
                  text: intl.formatMessage({ id: 'COMPANY.ADDNEWMETER' }),
                  class: 'btn btn-sm btn-primary',
                  icon: 'fas fa-tachometer-alt',
                  onClick: function (event: SyntheticEvent, refresh: Function) {
                    setItemIdForUpdate('add')
                    setRefreshFunction(() => refresh)
                  },
                },
              ]
            : []
        }
        //@ts-ignore
        location={location}
      />
      {itemIdForUpdate !== '' ? (
        <MetersEditModal
          show={itemIdForUpdate !== ''}
          itemIdForUpdate={itemIdForUpdate}
          companyId={companyId}
          canDelete={canDelete}
          onHide={() => {
            setItemIdForUpdate('')
          }}
          refreshFunction={(itemId: any) => {
            if (itemId !== undefined) {
              setItemIdForUpdate(itemId)
            }
            refreshFunction()
          }}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export { MetersList }
